export default "__VITE_ASSET__DUNRF1Gv__"